import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BossResources } from 'se-resource-types';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  public currentOrg: BossResources.Organization;

  public constructor(private activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {
    this.currentOrg = this.activatedRoute.snapshot.data.currentOrg;
  }
}
